// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '@shared/utils/theme'
// Layout
import WelcomePageWarning from './WelcomePageWarning'
import WelcomePageFileDeposit from './WelcomePageFileDeposit'

const WelcomePageActionsContainer = styled.div`
  margin-top: 20px;
  min-width: 275px;
`

export default function WelcomePageActions({ condition }) {
  return (
    <WelcomePageActionsContainer style={!condition?{backgroundColor:  theme.palette.light_grey }:{}}>
      { condition && <WelcomePageFileDeposit />}
      { !condition && <WelcomePageWarning />}
    </WelcomePageActionsContainer>
  )
}
